import type { InvoiceLineFormItem } from '../InvoiceLinesForm';

/**
 * A line's členění DPH, left out when it equals the line's loaded `vatCode` (null included), so the
 * stored one is kept; a line without one (`vatCode` undefined) sends whatever it holds.
 */
function changedVatCodeId(line: InvoiceLineFormItem): { vatCodeId?: string | null } {
  if (line.vatCodeId === undefined) return {};
  if (line.vatCode !== undefined && line.vatCodeId === (line.vatCode?.id ?? null)) return {};
  return { vatCodeId: line.vatCodeId };
}

/**
 * Picks the fields the mutation accepts. A server line keeps its `id` so it is updated in place;
 * a line added in the editor has none, and the local `key` is dropped.
 */
export function toCleanInvoiceLines(lines: InvoiceLineFormItem[]): InvoiceLineFormItem[] {
  return lines.map(line => ({
    ...(line.id ? { id: line.id } : {}),
    description: line.description,
    quantity: line.quantity,
    unitPrice: line.unitPrice,
    unit: line.unit,
    vatRate: line.vatRate,
    vatAmount: line.vatAmount,
    vatMode: line.vatMode,
    totalAmountNoVat: line.totalAmountNoVat,
    totalAmountInclVat: line.totalAmountInclVat,
    discountPercent: line.discountPercent,
    ean: line.ean,
    code: line.code,
    recyclingFee: line.recyclingFee,
    costCenterId: line.costCenterId,
    jobId: line.jobId,
    ...changedVatCodeId(line)
  }));
}
